import { isVideoCampaign } from 'services/campaignDimension';
import { isRealTimeReport } from './isRealTimeReport';
import { REALTIME_CAMPAIGN_SUFFIX, VIDEO_CAMPAIGN_SUFFIX } from './reportIdSuffixes';

export const resolveReportIdByCampaignDimension = (reportId, dimension) => {
    const cleanName = reportId.replace(VIDEO_CAMPAIGN_SUFFIX, '').replace(REALTIME_CAMPAIGN_SUFFIX, '');
    if (isRealTimeReport()) {
        return `${cleanName}${REALTIME_CAMPAIGN_SUFFIX}`;
    }
    if (isVideoCampaign(dimension)) {
        return `${cleanName}${VIDEO_CAMPAIGN_SUFFIX}`;
    }
    return cleanName;
};
